export default __webpack_public_path__ + "static/media/36_4_2.62751135.png";